// import PrimeApp from './PrimeApp';
import { Component, Modal, Log } from '@WidgetWorks';
import UploadButton from '../Shared/UploadButton';
import UploadRecommendationWindow from './UploadRecommendationWindow';

export default class UploadWindow extends Component {
    constructor(appConfig) {
        super(appConfig);

        // !! Decouple into a controller.
        this.recommendationWindow = new UploadRecommendationWindow(appConfig.childApps.UploadRecommendationWindow);
        this.recommendationWindow.init();

        this.apiFilter = this.productPageInfo.retailerConfig?.filter_config?.recommendation;
        // !! Decouple into a controller
        // Upload button instance. (Child app)
        this.uploadButton = new UploadButton(appConfig.childApps.UploadButton, this.apiFilter);
        this.uploadButton.goBack = false;
        this.uploadButton.displayApp = this;
        this.uploadButton.parentName = 'StyleSnap';

        this.mode = {
            current: 'upload',
            previous: 'upload',
            func: {
                recommendation: null,
                upload: this.uploadButton.uploadPicture, // will exist as this.uploadButton.uploadPicture
                cropper: null, // will exist as this.cropperButton.uploadPicture
            },
            params: {
                recommendation: [],
                upload: [],
                cropper: [],
            },
            instance: {
                recommendation: null,
                upload: this,
                cropper: null,
            },
        };

        // First interaction point
        this.interacted = false;

        // Designed to create an error. This
        // app is not supposed to have multiple points.
        this.elementCopies = null;
    }

    overrideHook() {}

    preRenderHook() {}

    beforeMountHook() {
        // Handlers
        this.root = this.element.shadowRoot.querySelector('section');
        this.insertUploadButton();

        // Add in the logo
        if (this.resources.upload_graphic) {
            const uploadGraphic = this.root.querySelector('#customer-upload-graphic');
            uploadGraphic.src = this.resources.upload_graphic;
        }

        // Assuming background is a child element of this.root
        // And if the close button id is present too
        // const background = this.root.querySelector('.background');
        const closeElements = this.root.querySelectorAll('[close]');
        closeElements.forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggleDisplay();
            });
        });
    }

    syncStateForRecommendation(file) {
        [this.recommendationWindow.mode.current, this.recommendationWindow.mode.previous] = ['upload', this.recommendationWindow.mode.current];
        this.recommendationWindow.mode.params.upload = [file];
        // this.recommendationWindow.mode.instance.upload = this;
    }

    uploadResponseAnalytics() {
        this.analytics.registerEvent('upload_response', 1, 'StyleSnap');
        // this.analytics.registerEvent('upload_seen', 1, 'StyleSnap');
    }

    insertUploadButton() {
        // Upload button is a child app with the
        // the rest of the apps details.

        // Initialise the app and get a handle on the
        // root element.
        this.uploadButton.init();
        this.uploadButtonElement = this.uploadButton.element;
        this.uploadButton.parentName = 'StyleSnap';

        // As this is a child app, the parent here is responsible for mounting
        // the application.
        this.uploadButton.mountElements(this.root);
    }

    errorPage(header = 'Error Occurred', message = 'An unknown error has occurred, please try again later') {
        this.modal = new Modal(this.root, header, message, this.language.upload_button_app.modal);
        this.modal.display();
    }

    renderUploadRecommendations(recommendations, usersPhoto) {
        this.toggleDisplay();
        this.toggleLoading();
        this.recommendationWindow.connectionDisplayApp();

        // this.recommendationWindow.mode.current = 'recommendation';

        this.recommendationWindow.renderUploadRecommendations(recommendations, usersPhoto);
    }

    postRenderHook() {
        return true;
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        return true;
    }

    async mountElement() {
        let counter = 0;

        if (this.mountPoints.length > 1) {
            console.log(...Log.w(`${this.constructor.name}`, 'WARN', 'App is singleton, only one point will be mounted'));
        }

        try {
            const point = this.mountPoints[0];
            const mountPoint = this.mountPoints[0].mount_points[0];
            await this.waitForElementToExist(mountPoint);
            const targetElement = document.querySelector(mountPoint);
            if (targetElement) {
                targetElement.appendChild(this.element);
            }

            // Insert attributes into the new elements
            this.root.setAttribute('mountId', point.mount_id);
            point.attributes.forEach((attr) => {
                this.root.setAttribute(attr, '');
            });

            this.root.setAttribute('mountPointIndex', counter);
            this.root.setAttribute('language', this.productPageInfo.languageCode);

            counter += 1;
        } catch (error) {
            console.warn(`Could not mount this element correctly ${error}`);
            console.log(...Log.w(`${this.constructor.name}`, 'ERROR', `Could not mount this element: ${error}`));
        }
        console.log(...Log.w(`${this.constructor.name}`, 'LOG', `Mounted ${counter} elements (Max 1)`));
        return true;
    }

    async init() {
        console.log(...Log.w(`${this.constructor.name}`, 'LOG', 'Initialising...'));

        // This hook will run the custom function defined in the override itself.
        this.overrideHook();

        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, mount it.
        // This is a singular mount, not copies.
        await this.mountElement();

        // Now mounted, run the post hooks
        this.postRenderHook();

        console.log(...Log.w(`${this.constructor.name}`, 'LOG', 'Initialised'));
    }

    toggleLoading() {
        const loader = this.root.querySelector('#loader');
        if (loader.style.display === 'none') {
            loader.style.display = 'block'; // Replace with the desired display value
        } else {
            loader.style.display = 'none';
            // setTimeout(() => {
            // }, 500);
        }
    }

    setArguments(element) {
        // !!!!!!! CONTINUE DEVELOPMENT. THIS IS A WORK IN PROGRESS
        // !!!!!! SEE CONFIG FILE.

        // Each app can pick what arguments it wants
        // via a whitelist. This app only cares about the following arguments;
        // "cache=false", "image-url=xyz.com", "size=s", "product-id=123456"
        // if args.cache, this.parentalArguments.cache = args.cache;
        const { attributes } = element;
        for (let i = 0; i < attributes.length; i += 1) {
            const attribute = attributes[i];
            const key = attribute.name;
            const { value } = attribute;

            switch (key) {
            case 'cache':
                this.parentalArguments.cache = value === 'true';
                break;
            case 'image-url':
                this.parentalArguments.imageUrl = value;
                break;
            case 'size':
                this.parentalArguments.size = value;
                break;
            case 'product-id':
                this.parentalArguments.productId = value;
                break;
            default:
                break;
            }
        }
    }

    openApp(element) {
        this.firstInteractionHook();

        // Arguments from the parent can be used in the internal app.
        // So here we extract all the arguments from the parent.
        // Given these argument we decide what behaviour is expected.
        // For example, we can pass a image_url and instead of making the user
        // upload an image, it downloads the one from the given url.
        // Although this app, will only forward these details to the appToDisplay.
        // The external app is expected to have this.

        // Clear all arguments.
        this.parentalArguments = {};
        this.setArguments(element);

        this.toggleDisplay();
    }

    anim() {
        if (this.root.style.display === 'none') {
            this.root.classList.remove('hidden');
            this.root.style.display = 'block';
            // Trigger a reflow to apply the initial style before adding the visuallyhidden class
            this.root.offsetHeight;
            this.root.classList.remove('visuallyhidden');
        } else {
            this.root.classList.add('visuallyhidden');

            // Delay the hiding to ensure the animation is visible
            setTimeout(() => {
                this.root.style.display = 'none';
                this.root.classList.add('hidden');
            }, 600); // Adjust the delay as needed to match your transition duration
        }
    }

    toggleDisplay() {
        if (this.root.style.display === 'none') {
            this.anim();
        } else {
            this.anim();
        }
    }
}
